import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = 'Currency';

const currencyStore = {
    namespaced: true,
    state:{
        totalItem:0,
        q : {
            tableNeedQuery: tableName,
            isOuterJoin: false,       
            searchCriteria: "",
            orderBy: "CurrencyCode,asc",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions:{
        getAllCurrency({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/qgl/listvalue', state.q).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        getEffectiveRate({commit,state},param){
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/common/geteffectiverate', JSON.stringify({fromCur: param.fromCur, valueDate: param.valueDate})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        saveCurrency({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(
                baseUrl + "/mm/save",
                JSON.stringify({
                    type: tableName,
                    modelList: param.currencyModel,
                    option: param.option
                })
                )
                .then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        exportFile({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
                .then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default currencyStore;